import React from 'react'
import { graphql } from 'gatsby'

import PageHeader from '../components/PageHeader'
import Content from '../components/Content'
import Layout from '../components/Layout'
import SVGIcon from '../components/SVGIcon'
import PostCard from '../components/PostCard'

// Export Template for use in CMS preview
export const ZineIndexPageTemplate = ({
  title,
  subtitle,
  featuredImage,
  content
}) => (
  <main className="DefaultPage">
    <PageHeader
      title={title}
      subtitle={subtitle}
      backgroundImage={featuredImage}
    />
    <section className="section">
      <div className="container">
        <Content source={content} />
      </div>
    </section>
    <section className="section">
      <div className="PostSection--Grid">
        <PostCard
          featuredImage="../images/rakuda_first_hyoushi.jpg"
          title="ラクダの鼻息創刊号"
          excerpt="写真とエッセイのZINEです"
          slug="/zine/1"
          categories={[]}
        />
        <PostCard
          featuredImage="../images/rakuda_second_cover.jpeg"
          title="ラクダの鼻息２号"
          excerpt="トラウマ・蓋"
          slug="/zine/2"
          categories={[]}
        />
        <PostCard
          featuredImage="../images/rakuda_third_cover.jpeg"
          title="ラクダの鼻息３号"
          excerpt="TRIPTRIPTRIP"
          slug="/zine/3"
          categories={[]}
        />
      </div>
    </section>
  </main>
)

const ZineIndexPage = ({ data: { page } }) => (
  <Layout
    meta={page.frontmatter.meta || false}
    title={page.frontmatter.title || false}
  >
    <ZineIndexPageTemplate {...page.frontmatter} body={page.html} />
  </Layout>
)
export default ZineIndexPage

export const pageQuery = graphql`
  query ZineIndexPage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      ...Meta
      html
      frontmatter {
        title
        subtitle
        featuredImage
        content
      }
    }
  }
`
